module.exports = __webpack_public_path__ + "img/H-63-ER-1500-MI.55703af8.png";